import { useState, useEffect, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { path: "/", label: "首頁" },
  { path: "/about", label: "關於我" },
  { path: "/testimonials", label: "成功見證" },
  { path: "/system", label: "芳香創富系統" },
  { path: "/coaching", label: "教練服務 / 課程" },
  { path: "/contact", label: "聯繫我 / 加入團隊" },
];

const logoUrl = "https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/9aa924cb31af5202bbd782f0a24da659.png";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleLinkClick = useCallback(() => {
    setMenuOpen(false);
  }, []);

  const isActive = (path: string) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 transition-shadow duration-200"
      style={{
        background: "rgba(248, 245, 240, 0.88)",
        backdropFilter: "blur(16px)",
        WebkitBackdropFilter: "blur(16px)",
        borderBottom: "1px solid rgba(212, 163, 115, 0.22)",
        boxShadow: "0 6px 24px rgba(0, 0, 0, 0.06)",
      }}
    >
      <nav className="mx-auto flex h-[72px] max-w-[1180px] items-center justify-between gap-x-10 lg:gap-x-14 px-4 md:px-6">
        {/* Brand with Logo */}
        <Link
          to="/"
          className="flex items-center gap-3 flex-shrink-0 cursor-pointer hover:opacity-90 transition-opacity duration-200"
        >
          <img
            src={logoUrl}
            alt="香氛女王的幸福大地 Logo"
            title="香氛女王的幸福大地"
            className="h-[40px] md:h-[50px] w-auto object-contain flex-shrink-0"
          />
          <span className="text-[1.125rem] md:text-[1.25rem] font-bold tracking-wide text-secondary-500 whitespace-nowrap transition-colors duration-200">
            香氛女王的幸福大地
          </span>
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-6 lg:gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-[1.0625rem] font-semibold whitespace-nowrap cursor-pointer transition-colors duration-200 rounded-full px-3.5 py-1.5 ${
                isActive(link.path)
                  ? "text-secondary-500 bg-[rgba(212,163,115,0.14)]"
                  : "text-secondary-500 hover:text-primary-500"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Mobile Hamburger */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden w-11 h-11 flex items-center justify-center cursor-pointer text-secondary-500"
          aria-label={menuOpen ? "關閉選單" : "開啟選單"}
        >
          <i
            className={`text-[1.5rem] ${
              menuOpen ? "ri-close-line" : "ri-menu-line"
            }`}
          ></i>
        </button>
      </nav>

      {/* Mobile Menu Panel */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          menuOpen ? "max-h-[34rem] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div
          className="mx-4 mb-3 rounded-[18px] px-5 py-4"
          style={{
            background: "rgba(248, 245, 240, 0.96)",
            backdropFilter: "blur(24px)",
            WebkitBackdropFilter: "blur(24px)",
            boxShadow: "0 6px 24px rgba(0, 0, 0, 0.06)",
            border: "1px solid rgba(212, 163, 115, 0.18)",
          }}
        >
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={handleLinkClick}
              className={`block py-3.5 text-[1.125rem] font-semibold cursor-pointer border-b last:border-b-0 transition-colors duration-200 ${
                isActive(link.path)
                  ? "text-primary-500 border-[rgba(212,163,115,0.18)]"
                  : "text-secondary-500 border-[rgba(212,163,115,0.10)] hover:text-primary-500"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </header>
  );
}